import { Language } from '../@types/common.types';

/**
 * The `languages` table serves two independent purposes, and picking the wrong
 * list is a real bug rather than a cosmetic one:
 *
 * - Offering a spoken-only language (Mandarin, Farsi) as an *interface*
 *   language gives the user an `INVALID_LOCALE` error from `updateLanguage`,
 *   which rejects anything not flagged `isPlatformLocale`.
 * - Filtering an interface-locale list into a *spoken* picker hides most of the
 *   languages a provider might actually speak.
 *
 * `useStaticData` exposes `uiLocales` / `spokenLanguages` already split. These
 * helpers are for the handful of components that query `GET_LANGUAGES`
 * directly instead.
 *
 * Both preserve the backend's ordering (`sortOrder`, then name).
 */

/** Languages the app ships a UI translation bundle for. */
export function toUiLocales(languages: Language[] | undefined): Language[] {
    return (languages ?? []).filter((language) => language.isPlatformLocale);
}

/** Languages a provider may list as one they speak. */
export function toSpokenLanguages(languages: Language[] | undefined): Language[] {
    return (languages ?? []).filter((language) => language.isSpokenOption);
}
